import ContextMenuComponent from '../../../../organisms/context-menu'
import SegmentedPickerComponent from '../../../../atoms/segmented-pickers'
import { isEmpty } from 'lodash'
import { MenuHeaderTabsContainer } from '../../styled-components'
import { memo } from 'react'

const MenuHeaderTabs = ({
  tabOptions,
  selectedName,
  selectedTab,
  handleSelectTab
}) => {
  if (isEmpty(tabOptions)) return null

  return (
    <>
      <MenuHeaderTabsContainer>
        <SegmentedPickerComponent.Root value={selectedName}>
          <SegmentedPickerComponent.List style={{ width: '100%' }}>
            {tabOptions.map((tab) => (
              <SegmentedPickerComponent.Trigger
                key={tab.name}
                value={tab.name}
                onClick={(event) => handleSelectTab(event, tab)}
              >
                {tab.name}
              </SegmentedPickerComponent.Trigger>
            ))}
          </SegmentedPickerComponent.List>
        </SegmentedPickerComponent.Root>
      </MenuHeaderTabsContainer>

      {selectedTab?.options.map((option) => (
        <ContextMenuComponent.Item key={String(option.id)} {...option} />
      ))}
    </>
  )
}

export default memo(MenuHeaderTabs)
